import { Component, OnInit, Inject } from '@angular/core';
import { LdsUserService } from '../../services/lds-user.service';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { LdsPrebuiltWschatService } from '../../lds-websocket-module/pre-built/lds-prebuilt-wschat.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LdsUserSettings, DialogData } from '../../interfaces/all';
@Component({
    selector: 'lds-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {
  public deviceTypes = [];
  public energySettings = {
    items: []
  };
  public settings: LdsUserSettings;
  constructor(public user: LdsUserService, private eventBus: LdsEventBusService, private wsService: LdsPrebuiltWschatService, public dialog: MatDialog) { }

  ngOnInit() {
    let deviceType = this.user.deviceTypes;
    this.user.currentModule = 'Settings';
    this.eventBus.subscribe('user-settings-loaded', (settings) => {
      if (settings) {
        this.energySettings = settings.settings[1];
        this.settings = settings.settings;
      }
    });

    for (const key in deviceType) {
      if (deviceType.hasOwnProperty(key)) {
        const element = deviceType[key];
        this.deviceTypes.push({
          label: key,
          value: element
        });
      }
    }

  }

  clicked(itemValue, selection) {
    itemValue.toggle = false;
    itemValue.value = selection;
    this.wsService.updateSettings(this.settings);
}

openDialog(itemValue): void {
    if (itemValue.type) {
        return;
    }
    const dialogRef = this.dialog.open(HomeConfigDialogComponent, {
        width: '250px',
        data: { tooltip: itemValue.tooltip, rule: itemValue.rule, validation: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
        if (result && result.validation === 'is-valid') {
            itemValue.value = result.value;
            this.wsService.updateSettings(this.settings);
        }
    });
}

}

@Component({
    selector: 'lds-home-config-dialog',
    templateUrl: 'lds-home-config-dialog.html',
    standalone: false
})
export class HomeConfigDialogComponent {

  constructor(
      public dialogRef: MatDialogRef<HomeConfigDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
      this.dialogRef.close();
  }

  dataChanged(event): void {
      if (event > 0) {
          this.data.validation = 'is-valid';
      } else {
          this.data.validation = 'is-invalid';
      }
  }
}
